<script>
    import Fa from 'svelte-fa';
    import * as Icons from '@fortawesome/free-solid-svg-icons';
    import SvelteMarkdown from 'svelte-markdown'


    export let elementData;

    // Get the icon name from element.data.icons and convert it to a FontAwesome icon
    const getIcon = (iconName) => {
        // Replace icon name kebab-case with camelCase using regex
        const iconNameCamelCase = iconName.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
        // console.log(iconNameCamelCase);
        // Remove the 'fas ' from the icon name
        const icon = iconNameCamelCase.replace('fas ', '');
        return Icons[icon];
    }

    const cleanMarkdown = (markdown) => {
        // Add space after series of #'s
        const cleanedMarkdown = markdown.replace(/(#+)([^#])/g, '$1 $2');
        return cleanedMarkdown;
    }

</script>

<div class="element type-panel">
    {#if elementData.type == 'panel'}
        <div class="panel">
            <div class="header">
                <div class="icon-wrapper">
                    <Fa icon={getIcon(elementData.data.icon)} class="fa-icon"/>
                </div>
            </div>
            <div class="element-content">
                <SvelteMarkdown source={cleanMarkdown(elementData.data.text)} />
            </div>
        </div>
    {/if}
</div>

<style>
    .element {
        display: inline-block;
        width: 100%;
        text-align: center;
    }
    .header, .element-content {
        padding: 10px;
    }
    .header {
        background-color: #e8e8e8;
    }
    .icon-wrapper {
        font-size: 1.5em;

    }


</style>